import { useEffect, useState, useLayoutEffect, useMemo } from "react";
import {useNavigate} from 'react-router-dom'
import { Cascader } from "antd-mobile";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import address from '../../images/charge/address.png'
import charge_icon from '../../images/charge/charge_icon.png'
import { modalConfirm, modalAlert } from "../../component/Modal/index";
import { getBuildingInfoApi,bindRoomApi } from  "../../http/request";
import { useStore } from "../../store/store";
type optionProps = {
  value: string
  label: string 
  label1?: string
  labelen1?: string
  labelen?: string
  isDisplayed: number
}
let roomOptions: optionProps [] = [] //保持房间列表
export default function Index() {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation();
  const [visible, setVisible] = useState<boolean>(false);
  const [value, setValue] = useState<any[]>([]);
  const { nkdSid, buildingName,  updateBuildingid,buildingNameEN,updatebuildingNameEN, updateBuildingName, username } = useStore((state) => state);
  const [name, setName] = useState< string []>( [buildingName,buildingNameEN])
  const [placeholder, setPlaceholder] = useState<string>(t("QY"));
  const areaBuild = [{levelName:'学生宿舍',buildingid:'学生宿舍',levelNameEn:'Student dormitory'},
  {levelName:'欣园',buildingid:'欣园',levelNameEn:'Joy Highland'},
  {levelName:'创园',buildingid:'创园',levelNameEn:'Chuang Yuan'},
  {levelName:'荔园',buildingid:'荔园',levelNameEn:'Lychee Hills'},
  {levelName:'慧园',buildingid:'慧园',levelNameEn:'Hui Yuan'},
  {levelName:'教师公寓',buildingid:'教师公寓',levelNameEn:'Faculty Apartments'},
  {levelName:'院士楼',buildingid:'院士楼',levelNameEn:'Lakeview Villas'},
  ]
  const [valueToOptions, setValueToOptions] = useState(
    {} as Record<string, any>
  );

  /**
   * @description 获取建筑信息
   */
  const getBuildingInfo = async (value: string) => {
    const res  = await getBuildingInfoApi({
      parentid: value
    })
    if (res.data.code == 0) {
      return res.data.list
    }
  }
  /**
   * @description 绑定房间
   * @returns 
   */
  const bindRoom = async () => {
    console.log(value)
    const buildingID = value.slice(-1)[0]
    console.log(buildingID)
    if (value.length < 4 || buildingID.length < 9) {
      await modalAlert({
        title: t("TS"),
        content: t("FJBNWK"),
        confirmText: t("ZDL"),
      });
      return;
    }
    const res = await modalConfirm({
      title: t("TS"),
      content: t("FJBDTEXT"),
      confirmText: t("QD"),
      cancelText: t("QX"),
    });

         //判断房间是被暂停
    const item = roomOptions.find((item) => item.value == buildingID)
      if (!(item as optionProps).isDisplayed) {
      await modalAlert({
          title: t("TS"),
          content:<div dangerouslySetInnerHTML={{ __html: t("ZTCZROOM") }}></div>,
          confirmText: t("ZDL"),
           });
         }
    if (res) {
      const result = await bindRoomApi({
        buildingid: buildingID,
        nkdSid: nkdSid,
        nkdName:username
      })
     if (result.data.code == 0) {
      updateBuildingid(buildingID)
      updateBuildingName(name[0])
      updatebuildingNameEN(name[1])
      await modalAlert({
        title: t("TS"),
        content: t('BDCG'),
        confirmText: t("ZDL"),
        onConfirm: () => {
          navigate('/')
        }
      });
      return
     }
     await modalAlert({
      title: t("TS"),
      content: result.data.msg,
      confirmText: t("ZDL"),
    });
    }
  };
  let options = useMemo(() => {
    function generate(v: string): any | undefined {
      const options = valueToOptions[v];
      if (options === null) {
        return undefined;
      }
      if (options === undefined) {
        return Cascader.optionSkeleton;
      }
      roomOptions = options
      return options.map((option: any) => {
       return {
          ...option,
          children: generate(option.value),
        }
      });
    }
    return generate("0") ?? [];
  }, [valueToOptions]);
  async function fetchOptionsForValue(v: any, level: number) {
    if (v in valueToOptions) return;
    if (level >= 4) {
      setValueToOptions((prev) => ({
        ...prev,
        [v]: null,
      }));
      return;
    }
    let buildData = null
    let options: any = []
   if (level == 0) {
    buildData = areaBuild
  } else if (level == 1) {
    buildData = await getBuildData('0');
  } else {
    buildData = await getBuildData(v);
  }

  if (buildData == null) {
    options = null
  } else {
    buildData.forEach((item: Record<string, any>) => {
      if(level == 1) {
       if ( item.levelName.includes(v)) {
        options.push({
          value: item.buildingid,
          label: i18n.language =='en'? item.levelNameEn: item.levelName,
          label1: item.aliasName,
          labelen1:item.aliasNameEn,
          labelen:item.levelNameEn,
          isDisplayed: item.isDisplayed,
          num:  item.aliasNameEn.match(/\d+/g)? item.aliasNameEn.match(/\d+/g).join(): 0
        })
       }
      } else {
        options.push({
          value: item.buildingid,
          label: i18n.language =='en'? item.levelNameEn: item.levelName,
          label1: item.aliasName,
          labelen1:item.aliasNameEn,
          labelen:item.levelNameEn,
          isDisplayed: item.isDisplayed,
        })
      }

    } )
  }
  //针对学生宿舍排序错落问题
  if (level == 1) {
    options.sort((a: any, b:any) => {
      return a.num - b.num;
    });
  }
    setValueToOptions((prev) => ({
      ...prev,
      [v]: options,
    }));
  }

  async function getBuildData(value: string) {
    return getBuildingInfo(value)
  }
  /**
   * @description 选中房间逻辑
   * @param val 
   * @returns 
   */
  const handlerConfirm = async (val: any []) => {
    const value = val.length;
    if (value != 4) {
      await modalAlert({
        title: t("TS"),
        content: t('FJBNWK'),
        confirmText: t("ZDL"),
      });
      return 
    }
    const buildingID = val[3];
    const option = roomOptions.find(item => item.value === buildingID)  as optionProps 
    setName([option.label1 as string,option.labelen1 as string])
  };
  /**
   * @description Placeholder中英转换
   * @param value 
   */
  const setlaceholder = (value: any[]) => {
    const len = value.length;
    switch (len) {
      case 1:
        setPlaceholder(t("LD"));
        break;
      case 2:
        setPlaceholder(t("LC"));
        break;
      case 3:
      setPlaceholder(t("FJ"));
        break;
    }
  };
  const showBuildName = useMemo(() => {
    if (name[0]) {
      return i18n.language == 'en' ? name[1] : name[0]
    } else {
      return  t('BINDADDREESS')
    }
  }, [name[0]])
  useEffect(() => {
    if (!nkdSid) {
      navigate('/login')
      return
    }
    document.title = t('BDFJ')
    return () => {};
  }, []);
  return (
    <div className={styles.main_container}>
      <div className={styles.background_line}></div>
      <div className={styles.room_view}  onClick={() => {
            fetchOptionsForValue("0", 0);
            setVisible(true);
          }} >
        <img src={address}  className={styles.address_icon} alt="" />
        <p>{showBuildName}</p>
        <img  src={charge_icon}
          className={styles.charge_icon}
          alt="" />
      </div>
      <Cascader
        options={options}
        title={`${t('QY')}-${t("LD")}-${t("LC")}-${t("FJ")}`}
        cancelText={t("QX")}
        confirmText={t("QD")}
        onConfirm={(val) => {
          setValue(val);
          handlerConfirm(val);
        }}
        placeholder={placeholder}
        onSelect={(value) => {
          value.forEach((v, index) => {
            fetchOptionsForValue(v, index + 1);
          });
          setlaceholder(value);
        }}
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
      />
      <div
        onClick={() => {
          bindRoom();
        }}
        className={styles.comfire}
      >
        {t("BD")}
      </div>
    </div>
  );
}
